export default __webpack_public_path__ + "static/media/forest.693409c2.webp";